import React from "react";
import Select from "react-select";
import '../App.css'

import { updatePointDataCnl } from '../Redux/Actions/mapDataActions'
import { Typography, Divider } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Cancel, Send } from "@mui/icons-material";
import { BUYEROPTIONS } from "../App.config";
import { getMarketOpportunities, getOutletCategories, getOutletTypes } from "../Redux/Actions/cnlActions";
import { connect } from "react-redux";


class UpdateDataCnl extends React.PureComponent {
    state = {
        currentData: '',
        isButtonLoading: false,
        outletTypes: []
    }

    componentDidMount(){
        const { dispatch, info} = this.props

        // Fetching all pType
        this.setState({currentData: info})

        // dispatch(getOutletTypes());
        // dispatch(getOutletCategories());
        // dispatch(getMarketOpportunities());

    }

    _setDropdownValue = (option, property) => {
        const propertyName = property.name;
        const value = option.value;

        this.setState({
            currentData: {
                ...this.state.currentData,
                [propertyName]:  value
            }
        })
    }


    // post point's update form data
    _postUpdatedData = async (e) => { 
        e.preventDefault();

        //  loader started
        this.setState({
            isButtonLoading: true
        })

        const {info, popupToast, updateInfo, dataUpdatePanelToggler } = this.props
        const { currentData } = this.state
        const {id} = info
        
        const params = {
            outlet_id: id,
            outlet_name: currentData.outlet_name,
            outlet_type: currentData.outlet_type,
            outlet_category: currentData.outlet_category,
            address:currentData.address,
            owner_name:currentData.owner_name,
            phone_number: currentData.phone_number,
            is_buyer:currentData.is_buyer,
            market_opportunity: currentData.market_opportunity,
            outlet_updated_at:`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,

            //** */ mandatory to update
            auto_assign_updated_by_user_id: 1,
            latitude: info.latitude,
            longitude: info.longitude,
        }

        //  set data as form data according to api need
        const formData = new FormData();
        Object.keys(params).forEach(key => formData.append(key, params[key]));

        // updating point data
        updatePointDataCnl(formData)
        .then(res=> {
            if(res?.status !== 200){
                // stop loading button from loading state
                this.setState({
                    isButtonLoading: false
                })
                popupToast(true)

                return
            }

            // stop loading button from loading state
            this.setState({
                isButtonLoading: false
            })
            
            popupToast(true)
            updateInfo(currentData)
            dataUpdatePanelToggler()

            this.setState({
                showPTypeSubTypeWarning: false
            })
        })
        .catch(err => {
            popupToast(false)
            this.setState({
                isButtonLoading: false
            })
            console.error(err)
        })
    }
    

    // Update data of all input field excep dropdown
    _updateCurrentDataState = (property, event) => {

        this.setState(prevState => ({
            currentData: {
                ...this.state.currentData,
                [property]: event.target.value
            }

        }))
    }

    render(){
        const { currentData, isButtonLoading } = this.state
        const { marketOpportunities, outletTypes, outletCategories } = this.props
        return (
            <div>
                <form action="" method="">
                    <Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Outlet Name :</Typography>
                    <input className='updateInput'  onChange={e => this._updateCurrentDataState('outlet_name', e)} type="text" name='shop-name' value={ currentData.outlet_name ?  currentData.outlet_name : ''} />

                    <Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Outlet Type :</Typography>
                    <Select
                        name='outlet_type'
                        id='outlet_type'
                        options={outletTypes}
                        label='Outlet Types'
                        onChange={this._setDropdownValue}
                        placeholder={currentData?.outlet_type}
                        defaultValue={currentData?.outlet_type }
                        isClearable={false}
                    />

<Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Is Buyer :</Typography>
                    <Select
                        name='is_buyer'
                        id='is_buyer'
                        options={BUYEROPTIONS}
                        label='Is Buyer'
                        onChange={this._setDropdownValue}
                        placeholder={(currentData.is_buyer === 1)? "Buyer" : "Non Buyer" }
                        defaultValue={(currentData.is_buyer === 1)? "Buyer" : "Non Buyer" }
                        isClearable={false}
                    />

                    <Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Outlet Category :</Typography>
                    <Select
                        name='outlet_category'
                        id='outlet_category'
                        options={outletCategories}
                        label='Outlet Category'
                        onChange={this._setDropdownValue}
                        placeholder={currentData?.outlet_category}
                        defaultValue={currentData?.outlet_category }
                        isClearable={false}
                    />

                    <Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Address :</Typography>
                    <input className='updateInput'  onChange={e => this._updateCurrentDataState('address', e)} type="text" name='shop-name' value={ currentData.address ?  currentData.address : ''} />
        
                    <Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Owner Name :</Typography>
                    <input className='updateInput'  onChange={e => this._updateCurrentDataState('owner_name', e)} type="text" name='shop-name' value={ currentData.owner_name ?  currentData.owner_name : ''} />
                    
                    <Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Is Buyer :</Typography>
                    <Select
                        name='is_buyer'
                        id='is_buyer'
                        options={BUYEROPTIONS}
                        label='Is Buyer'
                        onChange={this._setDropdownValue}
                        placeholder={(currentData.is_buyer === 1)? "Buyer" : "Non Buyer" }
                        defaultValue={(currentData.is_buyer === 1)? "Buyer" : "Non Buyer" }
                        isClearable={false}
                    />

                    <Typography ml={ 1 } variant={ 'body1' } htmlFor="shop-name">Market Opportunity :</Typography>
                    <Select
                        name='market_opportunity'
                        id='market_opportunity'
                        options={marketOpportunities}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                        label='Market Opportunity'
                        onChange={this._setDropdownValue}
                        placeholder={currentData?.market_opportunity}
                        defaultValue={currentData?.market_opportunity }
                        isClearable={false}
                    />

                    <div style={ STYLES.buttonContainer }>
                        <LoadingButton
                            variant={'contained'}
                            size={ 'small' }
                            loading={ isButtonLoading }
                            onClick={this._postUpdatedData}
                            sx={ STYLES.buttonStyle }
                            color={ 'text' }
                            endIcon={<Send />}
                        >
                            Update
                        </LoadingButton>
                        <LoadingButton
                            variant={'contained'}
                            size={ 'small' }
                            // loading={ isLoading }
                            startIcon={<Cancel />}
                            onClick={this.props.dataUpdatePanelToggler}
                            sx={ STYLES.buttonStyle }
                            color={ 'text' }
                        >
                            Close
                        </LoadingButton>
                    </div> 
                </form>
                <Divider sx={{ margin: '20px auto', width: '90%' }}/>
            </div>
        )
    }
}

const STYLES = {
    buttonContainer: { 
        width: '100%', 
        display: "flex", 
        alignItems: 'center', 
        margin: '20px auto',
    },
    buttonStyle: {
        padding: '4px 20px',
        margin: '0 5px 0 0',
        border: '1px solid #24242b56',
        borderRadius: '5px',
        fontWeight: 'bold',
        // color: '#202c39',
        backgroundColor: '#ffff',
        // boxShadow: '4px 4px 5px rgba(27, 27, 27, 0.151)'
    }
}

const mapStateToProps = (state) => ({
    outletTypes: state?.cnl.outletTypes ?? [],
    outletCategories: state?.cnl?.outletCategories ?? [],
    marketOpportunities: state?.cnl?.marketOpportunities ?? [],
})

const mapDispatchToProps = (dispatch) => ({dispatch})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDataCnl);
